import React from 'react';
import { AgeAntispoofingConfigPanel } from '@components/config/AgeAntispoofingConfigPanel';
import ConfigPanel, { ConfigProps } from '@components/config/ConfigPanel';

interface Props {
    onError: (error: Error) => void;
    configuration: ConfigProps;
    onConfigChange: (config: ConfigProps) => void;
}

const Settings: React.FC<Props> = ({ onError, onConfigChange, configuration }) => {
    return (
        <ConfigPanel twoSidesPanelDataQa="settings-two-sides-panel">
            <AgeAntispoofingConfigPanel
                config={configuration}
                onConfigChange={onConfigChange}
                onError={onError}
            />
        </ConfigPanel>
    );
};

export default Settings;
